import Vue from 'vue';
import axios from 'axios'
import { getAppBaseConfig } from '@/storage/services/AppBaseConfigService'
import store from '@/xreports/store/index'
import { v4 as uuidv4 } from 'uuid'
import { merge } from 'lodash'
import { Message } from 'element-ui'
import { clearHotelCemFilter, clearHotelCemDefault } from '@/storage/services/hotelcem/CommonFilterService'
import apiUtils from './api-utils'

// 国际化参数 START
import '@hotelcem/apis/interceptors/request/LangInterceptors'
// 国际化参数 END

// DEMO START
import '@hotelcem/apis/interceptors/response/DemoInterceptors'
// DEMO END
import '@hotelcem/apis/interceptors/response/DetailQueryInterceptors'

    import { readStatus } from '@/m/constants/dict'

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    

let token = localStorage.getItem('VOCUST_APP_BASE_ID')
  ? JSON.parse(localStorage.getItem('VOCUST_APP_BASE_ID')).token
  : 'not find'
const fatherSysAuthentication = {
  rms: 'Basic cm1zOnJtc19zZWNyZXQ=',
}
let Authorization = getAppBaseConfig().appId
if (window.location.href.includes('rms.')) {
  Authorization = fatherSysAuthentication.rms
}

let headers = {
  Authorization,
  'Cache-Control': 'no-cache',
  Pragma: 'no-cache',

  ContentType: 'application/json',
  reqId: uuidv4().replace(/-/g, ''),
}

if (token) {
  headers.token = token
}

if (getAppBaseConfig().loginSsoToken) {
  headers.ssoToken = getAppBaseConfig().loginSsoToken || ''
}

const getDefaultConfig = () => ({
  baseURL: `${process.env.VUE_APP_APIBASEURL}/api/v1/xreports`,
  withCredentials: true,
  timeout: 60000,
  headers: {
    Authorization,
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    token: getAppBaseConfig().token,

    ContentType: 'application/json',
    reqId: uuidv4().replace(/-/g, ''),
    ssoToken: getAppBaseConfig().loginSsoToken || '',
  },
  responseType: 'json',
  responseEncoding: 'utf8',
  cancelToken: apiUtils.createCancelToken(),
})

export async function fetch(otherConfig) {
  const config = merge({}, getDefaultConfig(), otherConfig)
  return axios({
    ...config,
    // timeout: config.url.includes('data-model/aggregated') ? 100 : 60000,
    //timeout: config.url.includes('dataCube/query2') ? 100 : 60000,
  })
    .then(res => {
      // res为null,还未请求到真实的接口，直接抛出异常
      if (!res?.data) {
        return Promise.reject({
          response: null,
        })
      }

      if (['GENERAL_ERROR_ALERT'].includes(res?.data.msgcode)) {
        Message.error({ message: res.data.message || res.data.msg })
      }
      // res.data.message = res.config.url
      // res.data.msg = res.config.url
      return Promise.resolve(res.data)
    })
    .catch(err => {
      // 用户主动取消请求
      if (err?.message?.code === -2000) {
        return Promise.resolve({
          code: -2000,
          data: {},
        })
      }
      // 统一处理接口错误信息

      console.error(`response error: url=${config.url}; reqId = ${config.headers.reqId}; `)
      if (!err.response) {
        // Message.error({ message: '网络异常，请稍后再试' })
        requestErrorMsg()
        return Promise.resolve({})
      }
      const { status, data } = err.response
      if (status === 401) {
        store
          .dispatch('systemUser/logout', {
            userLogout: !config.headers?.ssoToken,
          })
          .finally(() => {
            clearHotelCemFilter()
            clearHotelCemDefault()
          })
        return Promise.resolve(data)
      } else if (status === 500) {
        if (['GENERAL_ERROR_ALERT'].includes(err?.data?.code)) {
          Message.error({ message: err.data.msg || err.data.message })
        } else {
          // Message.error({ message: '网络异常，请稍后再试' })
          requestErrorMsg()
        }

        return Promise.resolve(data)
      } else {
        if (['GENERAL_ERROR_ALERT'].includes(err?.message?.code)) {
          Message.error({ message: err.data.msg })
          return Promise.resolve(data)
        }

        // 接口对应错误信息
        return Promise.resolve(data)
      }
    })
}

let showed = false
function requestErrorMsg() {
  if (showed) return
  showed = true
  Message.closeAll()
  Message.error({ message: $t('6ee78e') })
  setTimeout(() => {
    showed = false
  }, 5000)
}

export async function fecthGet(url, params = {}, config = {}) {
  return fetch({
    url,
    method: 'GET',
    params: params,
    ...config,
  })
}

export async function fecthPost(url, params = {}, config = {}) {
  return fetch({
    url,
    method: 'POST',
    data: params,
    ...config,
  })
}

export async function fecthDelete(url, params = {}, config = {}) {
  return fetch({
    url,
    method: 'DELETE',
    params: params,
    ...config,
  })
}
